import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ContentCard, DashboardHeader } from "../common/DashboardComponents";

import {
  fetchUsers,
  toggleUserStatus,
  fetchUserAttachments,
  fetchAllUsers,
} from "../../redux/actions/grievanceActions1";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FilePreviewModal from "../common/FilePreviewModal";

const Icons = {
  User: <i className="bi bi-person-fill"></i>,
  Document: <i className="bi bi-file-earmark-text"></i>,
};

const AresaUserDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { userDetails, id } = location.state;

  const [remarks, setRemarks] = useState("");
  const [document, setDocument] = useState([]);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [fileName, setFileName] = useState("");
  console.log(userDetails);

  // Handler function for input changes
  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const [processingAction, setProcessingAction] = useState(false);

  const fetchAttechment = async () => {
    const attechment = await dispatch(
      fetchUserAttachments(userDetails.USER_ID)
    );
    setDocument(attechment);
  };

  const userData = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    dispatch(fetchUsers(userData?.UNIT_CENTRE_ID));
    fetchAttechment();
  }, [dispatch]);

  const handleAccept = async (status, remarks) => {
    setProcessingAction(true);

    try {
      const res = await dispatch(
        toggleUserStatus(userDetails?.USER_ID, status, remarks)
      );
      if (res.rCode == 0) {
        if (status == 1) {
          alert("Accept Successfully!");
        } else {
          alert("Reject Successfully!");
        }

        navigate("/AresaUserList");
        await dispatch(fetchAllUsers());
      } else {
        toast.error("Error!", {
          position: "top-right",
          autoClose: 3000,
        });
      }
      console.log(res);
      setProcessingAction(false);
    } catch (error) {
      setProcessingAction(false);
      console.error("Failed to accept user:", error);
    }
  };

  const handleTimelineAttachmentPreview = (attachment, name) => {
    setPreviewAttachment(attachment);
    setFileName(name);
    setIsPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewAttachment(null);
  };

  return (
    <div className="container-fluid">
      <DashboardHeader title="User Details" />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <FilePreviewModal
        isOpen={isPreviewModalOpen}
        onClose={closePreviewModal}
        attachment={previewAttachment}
        fileTypes={fileName}
      />

      {/* Back button with modern styling */}
      <div className="mb-3">
        <button
          className="btn btn-outline-primary rounded-pill"
          onClick={() => navigate("/AresaUserList")}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Back to Users List
        </button>
      </div>

      {/* Main content container with modern styling - now vertical layout */}
      <div className="row">
        {/* User Information Card - full width */}
        <div className="col-12 mb-4">
          <ContentCard
            title="User Information"
            icon={Icons.User}
            className="shadow border-0 rounded-lg"
          >
            <div className="user-profile p-3">
              <div className="d-flex align-items-center mb-4">
                {/* User avatar with modern appearance */}
                <div
                  className="avatar rounded-circle p-3 me-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
                    width: "70px",
                    height: "70px",
                  }}
                >
                  <i className="bi bi-person-fill fs-1 text-white"></i>
                </div>
                <div>
                  <h4 className="mb-1 fw-bold">{userDetails?.USER_NAME}</h4>
                  <div className="mt-2">
                    <div
                      style={{
                        backgroundColor:
                          userDetails?.IS_STATUS === "0"
                            ? "#ff9800"
                            : userDetails?.IS_STATUS === "1"
                            ? "#4caf50"
                            : "#dc3545",
                        borderRadius: "50px",
                        textAlign: "center",
                        width: "120px",
                        padding: "4px 12px",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                      }}
                    >
                      <p className="text-white mb-0 fw-medium">
                        {userDetails?.IS_STATUS == "0"
                          ? "Pending"
                          : userDetails?.IS_STATUS == "1"
                          ? "Approved"
                          : userDetails?.IS_STATUS === "2"
                          ? "Rejected"
                          : "Unknown"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* User details with improved layout */}
              <div className="user-details p-3 rounded-3 bg-light">
                {/* <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">Email:</div>
                  <div className="col-md-10">{userDetails?.email}</div>
                </div> */}
                <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">
                    Service No:
                  </div>
                  <div className="col-md-10">{userDetails?.SERVICE_NO}</div>
                </div>
                <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">Phone:</div>
                  <div className="col-md-10">{userDetails?.MO_NO}</div>
                </div>
                <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">
                    Date of Birth:
                  </div>
                  <div className="col-md-10">{userDetails?.DOB || "N/A"}</div>
                </div>
                <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">
                    Date of Retirement:
                  </div>
                  <div className="col-md-10">{userDetails?.DOR || "N/A"}</div>
                </div>
                <div className="row mb-3 border-bottom pb-2">
                  <div className="col-md-2 fw-bold text-secondary">
                    Date of Enrollment:
                  </div>
                  <div className="col-md-10">{userDetails?.DOE || "N/A"}</div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-2 fw-bold text-secondary">
                    PPO Number:
                  </div>
                  <div className="col-md-10">
                    {userDetails?.PPO_NO || "N/A"}
                  </div>
                </div>
              </div>

              {/* Remarks with improved textarea styling */}
              {userDetails?.IS_STATUS == 0 && (
                <div className="remarks-container mt-4">
                  <form>
                    <div className="form-group">
                      <label
                        htmlFor="remarks"
                        className="form-label fw-bold mb-2"
                      >
                        Remarks:
                      </label>
                      <textarea
                        id="remarks"
                        name="remarks"
                        value={remarks}
                        onChange={handleRemarksChange}
                        placeholder="Enter your remarks here..."
                        rows="3"
                        className="form-control rounded-3 border-primary-subtle shadow-sm"
                        disabled={userData?.role === 4 || userData?.role === 6 || userData?.role === 7}
                      />
                    </div>
                  </form>
                </div>
              )}

              {/* Action buttons for pending users */}
              {(userDetails?.IS_STATUS == 0 && (userData?.role !== 4 && userData?.role !== 6 && userData?.role !== 7)) && (
                <div className="d-flex justify-content-end mt-4 gap-3">
                  <button
                    onClick={() => handleAccept(1, remarks)}
                    className="btn btn-success rounded-pill px-4 d-flex align-items-center shadow-sm"
                    disabled={processingAction}
                  >
                    <i className="bi bi-check-circle-fill me-2"></i>
                    Accept User
                  </button>
                  <button
                    onClick={() => handleAccept(2, remarks)}
                    className="btn btn-danger rounded-pill px-4 d-flex align-items-center shadow-sm"
                    disabled={processingAction}
                  >
                    <i className="bi bi-x-circle-fill me-2"></i>
                    Reject User
                  </button>

                  {processingAction && (
                    <div
                      className="spinner-border spinner-border-sm text-primary ms-2"
                      role="status"
                    >
                      <span className="visually-hidden">Processing...</span>
                    </div>
                  )}
                </div>
              )}
            </div>
          </ContentCard>
        </div>

        {/* User Attachments Card - now full width */}
        <div className="col-12">
          <ContentCard
            title="User Attachments"
            icon={Icons.Document}
            className="shadow border-0 rounded-lg"
          >
            {/* Header with action section */}
            <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
              <div>
                {processingAction ? (
                  <div className="d-flex align-items-center">
                    <div
                      className="spinner-border spinner-border-sm text-primary me-2"
                      role="status"
                    >
                      <span className="visually-hidden">Processing...</span>
                    </div>
                    <span>Processing...</span>
                  </div>
                ) : (
                  <span className="fw-bold">Document Files</span>
                )}
              </div>
            </div>

            {/* Document attachments with modern styling - MODIFIED to remove timeline line and circle */}
            <div className="card border-0 shadow-sm rounded-lg m-3">
              <div className="card-header bg-primary text-white rounded-top py-3">
                <h5 className="mb-0 fw-bold">
                  <i className="bi bi-file-earmark-text me-2"></i>
                  Document Attachments
                </h5>
              </div>
              <div className="card-body">
                {document && document.length > 0 ? (
                  <div className="timeline-container">
                    {document.map((entry, index) => (
                      <div key={index} className="timeline-item mb-3">
                        <div
                          className="timeline-content p-3 rounded-3 shadow-sm border"
                          style={{
                            backgroundColor: "#fff",
                            border: "1px solid #e9ecef",
                          }}
                        >
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="mb-0 fw-bold">
                              <i className="bi bi-file-earmark me-2 text-primary"></i>
                              {entry.att_name}
                            </h6>
                            <div>
                              <button
                                className="btn btn-sm btn-outline-primary rounded-pill"
                                onClick={() =>
                                  handleTimelineAttachmentPreview(
                                    entry.attachment,
                                    entry.att_name
                                  )
                                }
                              >
                                <i className="bi bi-eye me-1"></i> View
                              </button>
                            </div>
                          </div>
                          <p className="text-muted small mb-0">
                            <span className="fw-medium">Document ID:</span>{" "}
                            {entry.user_att_id}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="d-flex flex-column align-items-center justify-content-center p-5">
                    <div className="text-center mb-3">
                      <i className="bi bi-file-earmark-x fs-1 text-secondary opacity-50"></i>
                    </div>
                    <h5 className="text-secondary mb-2">
                      No Documents Available
                    </h5>
                    <p className="text-muted">
                      The user hasn't uploaded any documents yet.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </ContentCard>
        </div>
      </div>
    </div>
  );
};

export default AresaUserDetails;
